/* jshint -W003 */

// eslint-disable-next-line max-statements
(function () {

  function productMoveUpClick() {
    var op = $('#products option:selected');
    op.first().prev().before(op);
  }

  function productMoveDownClick() {
    var op = $('#products option:selected');
    op.last().next().after(op);
  }

  function removeProductClick() {
    var op = $('#products option:selected');
    op.remove();
    refreshProduct(null);
  }

  function getProduct(productId) {
    if (!window.helpConfig) {
      return null;
    }

    var intProductId = parseInt(productId, 10);
    var len = window.helpConfig.productConfig.length;
    for (var i = 0; i < len; i++) {
      var item = window.helpConfig.productConfig[i];
      if (item.id === intProductId) {
        return item;
      }
    }

    return null;
  }

  function getNewProductId() {
    if (!window.helpConfig) {
      return -1;
    }

    var maxProductId = 0;
    var len = window.helpConfig.productConfig.length;
    for (var i = 0; i < len; i++) {
      var item = window.helpConfig.productConfig[i];
      if (item.id > maxProductId) {
        maxProductId = item.id;
      }
    }

    return maxProductId + 1;
  }

  function getNavigationCategoryHtml(idx) {
    var navCategoryHtml = '' +
      '<tr id="navCategoryRow' + idx + '">' +
      '  <td>' +
      '    <select id="productNav' + idx + '" class="form-control nav-category-select">' +
      '    </select>' +
      '  </td>' +
      '  <td>' +
      '    <input id="productArticles' + idx +
      '" type="text" placeholder="Article Ids" class="form-control">' +
      '  </td>' +
      '  <td>' +
      '    <div data-row="' + idx + '" class="uxicon uxicon-delete-fill"></div>' +
      '  </td>' +
      '</tr>';

    return navCategoryHtml;
  }

  function getNewNavCategoryIdx() {
    var maxIdx = -1;

    $('.uxicon-delete-fill').each(function (i, item) {
      var rowIdx = parseInt($(item).attr('data-row'), 10);
      if (rowIdx > maxIdx) {
        maxIdx = rowIdx;
      }
    });

    return maxIdx + 1;
  }

  function addNavCategoryRow() {
    var newIdx = getNewNavCategoryIdx();
    $('#productNavCategories').append(getNavigationCategoryHtml(newIdx));
    $('#productNav' + newIdx).html($('#productNavs').html());
    $('#productNav' + newIdx).val('Support:Product:Nav:GettingStarted');
    $('#productArticles' + newIdx).val('');
    $('.uxicon-delete-fill').on('click', deleteNavCategoryRow);
  }

  function deleteNavCategoryRow() {
    var rowIdx = $(this).attr('data-row');
    var navCategoryRow = $('#navCategoryRow' + rowIdx);
    navCategoryRow.remove();
  }

  function getProductSlug(text, id) {

    text = text.replace(/@/g, 'at');
    text = text.replace(/&/g, 'and');
    text = text.replace(/%/g, 'percent');

    text = text.toLowerCase();                      // lower case
    // eslint-disable-next-line no-useless-escape
    text = text.replace(/[_()\s{}\[\]<>]+/g, '-');  // braces, underscores, spaces to dash
    // eslint-disable-next-line no-useless-escape
    text = text.replace(/[^a-z0-9\-]/g, '');        // remove non alphanumeric / non-dash
    text = text.replace(/(-){2,}/g, '-');           // multiple dashes to single
    text = text.replace(/^-|-$/g, '');              // remove leading/trailing dashe

    return text + '-' + id;
  }

  // eslint-disable-next-line max-statements
  function refreshProduct(product) {
    if (product) {
      $('#productId').html(product.id);
      $('#productName').val(window.helpConfig.productNames[product.name]);
      $('#productImage').val(product.image);
      $('#productGroup').val(product.group);
      $('#productTopics').val(product.topics.join(', '));
      $('#productForums').val(product.forums ? product.forums.join(', ') : '');
      $('#productGetStarted').val(
        window.helpConfig.productGetStarted[product['get-started-text']]);
      $('#productGetStartedArticle').val(product['get-started-article']);
      $('#productGetStartedIntl').attr('checked', product['get-started-intl']);
      $('#productMarkets').val(product.markets.split(',').join(', '));
      $('#productSlug').html(getProductSlug(
        window.helpConfig.productNames[product.name], product.id));

      $('#productNavCategories').empty();
      $.each(product.nav, function (i, item) {
        $('#productNavCategories').append(getNavigationCategoryHtml(i));
        $('#productNav' + i).html($('#productNavs').html());
        $('#productNav' + i).val(item.name);
        $('#productArticles' + i).val(item.articles.join(', '));
      });
      $('.uxicon-delete-fill').on('click', deleteNavCategoryRow);

      $('#saveProduct').html('Update');
    } else {
      $('#productId').html(getNewProductId());
      $('#productName').val('');
      $('#productImage').val('');
      $('#productGroup').val('');
      $('#productTopics').val('');
      $('#productForums').val('');
      $('#productGetStarted').val('');
      $('#productGetStartedArticle').val('');
      $('#productGetStartedIntl').attr('checked', false);
      $('#productMarkets').val('');
      $('#productSlug').html('');

      $('#productNavCategories').empty();
      addNavCategoryRow();

      $('#saveProduct').html('Add');
    }

    productNameChange();
    $('#saveProduct').show();
  }

  function createNameKey(type, name) {
    name = name.replace(/[^a-zA-Z0-9]/g, '');
    name = name.substr(0, 30);
    return type + name;
  }

  function productsChange() {
    var productId = $('#products').val();
    var product = getProduct(productId);
    refreshProduct(product);
  }

  function newProductClick() {
    $('#products').val(null);
    refreshProduct(null);
  }

  function getNameKeyForText(collection, text) {
    for (var key in collection) {
      if (collection.hasOwnProperty(key) && collection[key] === text) {
        return key;
      }
    }
    return null;
  }

  // eslint-disable-next-line max-params
  function setKeyForText(obj, prop, val, type, collection) {
    obj[prop] = getNameKeyForText(collection, val);
    if (!obj[prop]) {
      obj[prop] = createNameKey(type, val);
      collection[obj[prop]] = val;
    }
  }

  // eslint-disable-next-line max-statements
  function saveProductClick() {

    var adding = false;
    var product = getProduct($('#productId').html());
    if (!product) {
      adding = true;
      product = {};
      product.id = parseInt($('#productId').html(), 10);
      window.helpConfig.productConfig.push(product);
    }

    var nameVal = $('#productName').val().trim();
    if (!nameVal.length) {
      $('#productConfigDialog')
        .attr('data-title', (adding ? 'Add' : 'Update') + ' Product Configuration')
        .html('Product Name is required')
        .sfDialog();

      $('.sf-dialog-buttons .btn-primary').on('click', function () {
        $('.sf-dialog .close').click();
      });

      return;
    }

    setKeyForText(product, 'name', nameVal, 'Support:Product:Name:',
      window.helpConfig.productNames);

    product.image = $('#productImage').val();
    product.group = $('#productGroup').val();

    product.topics = [];
    var topicIds = $('#productTopics').val().replace(/\s/g, '').split(',');
    for (var i = 0, len = topicIds.length; i < len; i++) {
      var topicId = parseInt(topicIds[i], 10);
      if (!isNaN(topicId)) {
        product.topics.push(topicId);
      }
    }

    product.forums = [];
    var forumIds = $('#productForums').val().replace(/\s/g, '').split(',');
    forumIds.forEach(function (forumId) {
      product.forums.push(forumId);
    });

    var getStarted = $('#productGetStarted').val().trim();
    if (getStarted.length) {
      setKeyForText(product, 'get-started-text', getStarted, 'Support:GettingStarted:Product:',
        window.helpConfig.productGetStarted);
    } else {
      product['get-started-text'] = '';
    }

    product['get-started-article'] = $('#productGetStartedArticle').val().trim();
    product['get-started-intl'] = ($('#productGetStartedIntl').attr('checked') === 'checked');
    product.markets = $('#productMarkets').val().replace(/\s/g, '');

    product.nav = [];
    $('#productNavCategories .uxicon-delete-fill').each(function (i, item) {
      var rowIdx = $(item).attr('data-row');

      var navItem = {};
      navItem.name = $('#productNav' + rowIdx).val();

      navItem.articles = [];
      var articleIds = $('#productArticles' + rowIdx).val().replace(/\s/g, '').split(',');
      for (var j = 0, lenj = articleIds.length; j < lenj; j++) {
        var articleId = parseInt(articleIds[j], 10);
        if (!isNaN(articleId)) {
          navItem.articles.push(articleId);
        }
      }

      product.nav.push(navItem);
    });

    if (adding) {
      $('#products').append('<option value="' + product.id + '">' +
        window.helpConfig.productNames[product.name] + '</option>');
      $('#products').val(product.id);
    } else {
      $('#products option[value="' + product.id + '"')
        .html(window.helpConfig.productNames[product.name]);
    }

    productsChange();
  }

  function productNameChange() {
    var name = $('#productName').val().trim();
    if (name.length) {
      $('#saveProduct').removeClass('disabled');
    } else {
      $('#saveProduct').addClass('disabled');
    }

    return true;
  }

  function productNavNameChange() {
    var navName = $('#productNavName').val().trim();
    if (navName.length) {
      $('#saveNavCategoryString').removeClass('disabled');
    } else {
      $('#saveNavCategoryString').addClass('disabled');
    }

    return true;
  }

  function updateNavCategoriesList() {
    var productNavList = $('#productNavs');
    productNavList.empty();

    var keys = Object.keys(window.helpConfig.productNavs).sort();
    keys.forEach(function (productNavKey) {
      productNavList.append('<option value="' + productNavKey +
        '">' + window.helpConfig.productNavs[productNavKey] + '</option>');
    });

    saveProductClick();
    productsChange();
  }


  function saveNavCategoryStringClick() {
    var navName = $('#productNavName').val().trim();
    if (navName) {

      var navNameKey = getNameKeyForText(window.helpConfig.productNavs, navName);
      if (!navNameKey) {
        navNameKey = createNameKey('Support:Product:Nav:', navName);
        window.helpConfig.productNavs[navNameKey] = navName;
        updateNavCategoriesList();
      }

      $('#productNavName').val('');
      $('#saveNavCategoryString').addClass('disabled');
    }
  }

  function ready() {
    var productConfig = $('#productMoveUp');
    if (productConfig.length) {
      $('.ux-pagetitle').hide();

      var configTab = $('.sf-tabs-menu.nav-tabs').children().last();
      configTab.find('a').on('click', genProductConfigClick);

      var firstId = $('#products').children().first().val();
      $('#products').val(firstId);
      productsChange();
    }
  }

  function createSelection(field, start, end) {
    if (field.createTextRange) {
      var selRange = field.createTextRange();
      selRange.collapse(true);
      selRange.moveStart('character', start);
      selRange.moveEnd('character', end);
      selRange.select();
      field.focus();
    } else if (field.setSelectionRange) {
      field.focus();
      field.setSelectionRange(start, end);
    } else if (typeof field.selectionStart !== 'undefined') {
      field.selectionStart = start;
      field.selectionEnd = end;
      field.focus();
    }
  }

  function genProductConfigClick() {
    var newConfig = [];
    $('#products').children().each(function (i, productId) {
      newConfig.push(getProduct($(productId).attr('value')));
    });
    window.helpConfig.productConfig = newConfig;

    var productConfiguration = JSON.stringify(window.helpConfig, null, 2);
    $('#productConfigText').val(productConfiguration);
    createSelection($('#productConfigText')[0], 0, 500000);
  }


  $('#productMoveUp').on('click', productMoveUpClick);
  $('#productMoveDown').on('click', productMoveDownClick);
  $('#removeProduct').on('click', removeProductClick);
  $('#saveProduct').on('click', saveProductClick);
  $('#products').on('change', function () { productsChange(); });
  $('#newProduct').on('click', function () { newProductClick(); });
  $('.uxicon-add-fill').on('click', addNavCategoryRow);
  $('#saveNavCategoryString').on('click', saveNavCategoryStringClick);
  $('#productName').on('input', productNameChange);
  $('#productNavName').on('input', productNavNameChange);
  $('#genProductConfig').on('click', genProductConfigClick);
  $(document).ready(ready);

}());

/* jshint +W003 */
